import React from "react";
import "./VideoMarker.css";

const VideoMarker = ({ point, isActive }) => {
  if (!point) return null;

  return (
    <div
      className={`video-marker ${isActive ? "active" : ""}`}
      style={{
        left: `${point.x}%`,
        top: `${point.y}%`,
      }}
    />
  );
};

export default VideoMarker;
